export {
  defaultTreeItems
} from './helper/cascadeTree';

export const PROJECTS_INDEX = 2, DESIGN_INDEX = 0, TRASH_INDEX = 3;